import React from "react";
import "./freemoney.css";

function FreeMoney() {
  return (
    <div className="freemoney-container">
        
        <div className="terminalContent">
          <div className="arrows-container">
            <div className="arrow">↑</div>
            <div className="arrow">↑</div>
            <div className="arrow">↑</div>
          </div>
          <h1 className="look-up-text">LOOK UP!</h1>
          <div className="arrows-container">
            <div className="arrow">↑</div>
            <div className="arrow">↑</div>
            <div className="arrow">↑</div>
          </div>
          <div className="troll-emoji">🤡</div>
        
          </div>
          </div>
  );
}

export default FreeMoney;
